<template>
  <div class='add'>
    <el-form ref="form" size="small" :model="data" :rules="rules" label-width="100px">
      <el-form-item label="标题" prop="complaint_title">
        <el-input v-model="data.complaint_title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="complaint_type_id">
        <el-select v-model="data.complaint_type_id" placeholder="请选择类型">
          <el-option :label="item.name" :value="item.id" v-for="item in type" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否匿名" prop="is_anonymous">
        <el-switch
          v-model="data.is_anonymous"
          active-value="1"
          inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="接收人" prop="receiver_id">
        <el-select v-model="data.receiver_id" placeholder="请选择接收人">
          <el-option :label="item.name" :value="item.id" v-for="item in receiverList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="被投诉人" prop="respondent_id">
        <el-tag type="success" v-for="item in data.respondent_id" :key="item.emplId" style="margin-right:10px">{{item.name}}</el-tag>
        <el-button plain type="primary" icon="el-icon-plus" size="small" @click="addHandler('respondent_id','被投诉人')">添加被投诉人</el-button>
      </el-form-item>
      <el-form-item label="投诉内容" prop="complaint_contents">
        <el-input type="textarea" :autosize="{minRows: 5}" v-model="data.complaint_contents" placeholder="请输入投诉内容"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      receiverList:[],
      rules:{
        complaint_title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        complaint_type_id: [
          { required: true, message: '请选择投诉类型', trigger: 'change' }
        ],
        is_anonymous: [
          { required: true, message: '请选择是否匿名', trigger: 'change' }
        ],
        receiver_id: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ],
        // respondent_id: [
        //   { required: true, type:'array', message: '请选择被投诉人', trigger: 'change' }
        // ],
        complaint_contents: [
          { required: true, message: '请输入投诉内容', trigger: 'blur' }
        ],
      },
      data:{
        is_anonymous:'1',
        respondent_id:[]
      },
    }
  },
  components: {},
  computed: {
    ...mapState({
      "type": state => state.suggestion.type
    })
  },
  watch: {},
  created() {
    this.init();
    console.log('测试构建')
  },
  mounted() {},
  methods: {
    init(){
      this.$axios.get('/receiver').then(res => {
       this.receiverList = res.data.records.map(item => {
          return {
            name: item.receiver_name,
            id: item.receiver_dd_id
          }
        });
      })
    },
    addHandler(data,text){
      this.$dd.ready(()=> {
        this.$dd.biz.contact.complexPicker({
          title:"选择"+text,            //标题
          corpId:this.$store.state.user.corpId,              //企业的corpId
          multiple:false,            //是否多选
          limitTips:"超出了",          //超过限定人数返回提示
          maxUsers:1,            //最大可选人数
          pickedUsers:this.data[data].map(item=>item.emplId),            //已选用户
          pickedDepartments:[],          //已选部门
          disabledUsers:[],            //不可选用户
          disabledDepartments:[],        //不可选部门
          requiredUsers:[],            //必选用户（不可取消选中状态）
          requiredDepartments:[],        //必选部门（不可取消选中状态）
          appId:22488,              //微应用的Id
          permissionType:"GLOBAL",          //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly:true,        //返回人，或者返回人和部门
          startWithDepartmentId:0 ,   //仅支持0和-1
          onSuccess: res=> {
            this.data[data]=res.users;
            this.$refs.form.validateField(data);
              /**
              {
                  selectedCount:1,                              //选择人数
                  users:[{"name":"","avatar":"","emplId":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                  departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
              }
              */
          },
          onFail : err=> {

          }
        });
      })
    },
    submit(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$axios.post('/complaint',{
            complaint_title:this.data.complaint_title,
            complaint_type_id:this.data.complaint_type_id,
            is_anonymous:this.data.is_anonymous,
            receiver_id:this.data.receiver_id,
            respondent_id:this.data.respondent_id[0]?this.data.respondent_id[0].emplId:'',
            complaint_contents:this.data.complaint_contents
          }).then(res=>{
            this.$message.success('创建成功！');
            this.$router.push({
              name:'我的'
            })
          })
        } else {
          this.$message.error('请输入必填项！')
          return false;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
</style>